import AccountProfileRoutes from "./accountProfile";
import AccountSettingsRoutes from "./accountSettings";
import LocationAndTaxRoutes from "./locationAndTax";
import OrganizationHierarchyRoutes from "./organizationHierarchy";
import RolesAndPrivilegesRoutes from "./rolesAndPrivileges";
import RolesAndPrivileges from "./rolesAndPrivileges";
import RouteSettingsRoutes from "./routeSettings";
import VehiclesRoutes from "./vehicles";
import TrackingRoutes from "./tracking";
import UserAndGroupsRoutes from "./usersAndGroups";
import DNSRoutes from "./dns";
import PaymentAndCollections from "./paymentAndCollections";
import PricingAndCollections from "./pricingAndCollections";
import Messaging from "./messaging";
import Approval from "./approval";


export default [
  {
    path: "/settings",
    name: "ProfileSettings",
    component: () => import("@/views/3pl/Settings/index"),
  },
  
  ...Approval,
  ...PricingAndCollections,
  ...PaymentAndCollections,
  ...TrackingRoutes,
  ...AccountProfileRoutes,
  ...AccountSettingsRoutes,
  ...LocationAndTaxRoutes,
  ...OrganizationHierarchyRoutes,
  ...RolesAndPrivilegesRoutes,
  ...RolesAndPrivileges,
  ...RouteSettingsRoutes,
  ...UserAndGroupsRoutes,
  ...VehiclesRoutes,
  ...DNSRoutes,
  ...Messaging
];
